import { render, staticRenderFns } from "./TagThankYouPage.vue?vue&type=template&id=44b5a0d6&"
import script from "./TagThankYouPage.vue?vue&type=script&lang=js&"
export * from "./TagThankYouPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports